import { DEFAULT_PREFECTURE_ID, DEFAULT_CITY_ID } from './CommonType';

import { getMainteDefault } from '../../utils/dateUtil';

// 機器行
export type DeviceInfoRow = {
    deviceRowNumber: number; // 機種行No
    modelid?: number; // 機種id
    makerName: string; // メーカー名
    modelName: string; // 機種名
    searchWord: string; // 検索キーワード
    modelType: string; // 型番
    inputList: Array<DeviceInfoInputRow>; // ToDo:機器行に編集行をArrayとして定義するかは要検討
};

// 編集行
export type DeviceInfoInputRow = {
    deviceRowNumber?: number; // 機器行No
    inputRowNumber?: number; // 編集行No
    prefectureId?: string; // 都道府県ID
    prefectureName?: string; // 都道府県名称
    cityId?: string; // 都市ID
    cityName?: string; // 都市名称
    unitCount?: string; // 設置台数
    freeText?: string; // 備考
};

// 見積りリスト
export type EstimatePattern = {
    estimatePatternRowNumber: number; // 編集行（見積り条件）
    estimatePatternName: string; // 見積りリスト名称
    estimateList: Array<EstimateDetail>;
    checkAllFlag: boolean; // 全選択フラグ
};

// 見積り詳細
export type EstimateDetail = {
    deviceRowNumber: number; // 機器行（保有機器の機器行No）
    inputRowNumber: number; // 編集行（保有機器の編集行No）
    startYear: string; // 開始年
    startMonth: string; // 開始月
    endYear: string; // 終了年
    endMonth: string; // 終了月
    maintenanceLevelCode: string; // メンテナンスID
    checkFlag: boolean; // チェックフラグ
};

// 見積り問合せ
export type EstimateInquiry = {
    deviceList: Array<DeviceInfoRow>;
    estimatePatternList: Array<EstimatePattern>;
};

// 編集行初期値
export const INIT_DEVICE_INFO_INPUT_ROW: DeviceInfoInputRow = {
    deviceRowNumber: 1,
    inputRowNumber: 1,
    prefectureId: DEFAULT_PREFECTURE_ID,
    prefectureName: '東京都',
    cityId: DEFAULT_CITY_ID,
    cityName: '文京区',
    unitCount: '1',
    freeText: '',
};
// 機器行初期値
export const INIT_DEVICE_INFO_ROW: DeviceInfoRow = {
    deviceRowNumber: 1,
    modelName: '',
    makerName: '',
    modelType: '',
    searchWord: '',
    inputList: [INIT_DEVICE_INFO_INPUT_ROW],
};
// 見積り条件初期値
export const INIT_ESTIMATE_PATTERN: EstimatePattern = {
    estimatePatternRowNumber: 1,
    estimatePatternName: '',
    estimateList: [],
    checkAllFlag: true,
};

// 保守期間年月初期値
const [startDate, endDate] = getMainteDefault();

// 見積条件 初期値
export const ESTIMATE_DETAIL_INIT: EstimateDetail = {
    deviceRowNumber: 1,
    inputRowNumber: 1,
    startYear: startDate.getFullYear().toString(),
    startMonth: (startDate.getMonth() + 1).toString(),
    endYear: endDate.getFullYear().toString(),
    endMonth: (endDate.getMonth() + 1).toString(),
    maintenanceLevelCode: '3',
    checkFlag: true,
};
// 見積り問合せ初期値
export const INIT_ESTIMATE_INQUIRY: EstimateInquiry = {
    deviceList: [],
    estimatePatternList: [INIT_ESTIMATE_PATTERN],
};
export const PATTERN_NAME_LEN = 512;
export const DEVICE_MEMO_MAX_LEN = 512;
// 見積条件全体 初期値
export const ESTIMATE_PATTERN_LIST_INIT: Array<EstimatePattern> = [INIT_ESTIMATE_PATTERN];
// state更新方法のコレクション
export type SetStateEstimate = {
    setStateEstimatePattern: (changeEstimatePatternData: EstimatePattern) => void;
    setStateEstimateDetail: (changeEstimateDetailData: EstimateDetail, changeEstimatePatternRowNumber: number) => void;
    setStateEstimateDetailCheckFlagAll: (changeCheckFlag: boolean, changeEstimatePatternRowNumber: number) => void;
    deleteStateEstimatePattern: (deleteEstimatePatternRowNumber: number) => void;
    addStateEstimatePattern: () => void;
};

// 設置場所編集プロパティ
export type ChangeFieldItemInput = {
    prefectureId?: string; // 都道府県ID
    prefectureName?: string; // 都道府県名称
    cityId?: string; // 都市ID
    cityName?: string; // 都市名称
    unitCount?: string; // 設置台数
    freeText?: string; // 備考
};

// 設置場所編集の初期値(都道府県のコードの未設定パターン)
export const CHANGE_FIELD_ITEM_DEFAULT: ChangeFieldItemInput = {
    prefectureId: DEFAULT_PREFECTURE_ID,
    cityId: DEFAULT_CITY_ID,
    unitCount: '1',
    freeText: '',
};

// モーダル選択機器のチェック
export type CheckedDeviceInfoProps = {
    deviceRowNumber: number;
    inputRowNumber: number;
    checked: boolean;
};
